/**
 * BackendTransactionTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {BackendTransaction} from "./BackendTransaction";
import {BackendTransactionCollection} from "./BackendTransactionCollection";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendTransactionTag extends TagAbstract {
    /**
     * Returns a specific transaction
     *
     * @returns {Promise<BackendTransaction>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async get(transactionId: string): Promise<BackendTransaction> {
        const url = this.parser.url('/backend/transaction/$transaction_id<[0-9]+>', {
            'transaction_id': transactionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendTransaction;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of transactions
     *
     * @returns {Promise<BackendTransactionCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(startIndex?: number, count?: number, search?: string, from?: string, to?: string, planId?: number, userId?: number, appId?: number, status?: string, provider?: string, taxonomy?: number): Promise<BackendTransactionCollection> {
        const url = this.parser.url('/backend/transaction', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
                'from': from,
                'to': to,
                'planId': planId,
                'userId': userId,
                'appId': appId,
                'status': status,
                'provider': provider,
                'taxonomy': taxonomy,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendTransactionCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
